import { TeachingBlockVersionSubjectsTable } from '../../../../../../components/TeachingBlockVersion/TeachingBlockVersionDataTables/TeachingBlockVersionSubjectsTable';
import { hexToColorOption } from '../../../../../../utils/colorUtils';
import { TeachingBlockResourceConfig, TeachingBlockResourceDataPage } from '../TeachingBlockResourceDataPage';

const subjectConfig: TeachingBlockResourceConfig = {
  entityType: 'subject',
  exclusionHolderType: 'Subject',
  relationKey: 'subjects',
  lessonFilterColumn: 'subject',
  searchName: 'subject-search',
  importLabelKey: 'subject.title',
  getVersionUuids: (store) => Array.from(store.subjects.keys()),
  importDisabled: (store, basicData) => {
    const versionSubjects = Array.from(store.subjects.keys()).length;
    const basicSubjects = basicData.subjectData?.subjects.filter((s) => s.epochEnabled).length ?? 0;
    return store.readonly || versionSubjects >= basicSubjects;
  },
  getRows: (basicData, versionUuids) =>
    basicData.subjectData?.subjects
      .filter((c) => versionUuids.includes(c.uuid))
      .map((c) => {
        const { html, label } = hexToColorOption(c.timetableConfig?.color ?? '');
        return {
          color: { color: html, label },
          count: 0,
          name: c.name,
          shortName: c.shortName,
          uuid: c.uuid,
        };
      }) ?? [],
  removeEntities: (store, uuids) => store.removeSubjects(uuids),
  renderTable: ({ versionUuid, search, versionUuids, onRowSelection, onShowLessonClick, onRemove }) => (
    <TeachingBlockVersionSubjectsTable
      versionUuid={versionUuid}
      search={search}
      versionSubjectUuids={versionUuids}
      onRowSelection={onRowSelection}
      onShowLessonClick={onShowLessonClick}
      onRemove={onRemove}
    />
  ),
};

export const PlanTeachingBlockSubjects = () => <TeachingBlockResourceDataPage config={subjectConfig} />;
